import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import IntegrationCallsApi from '../generated/api/IntegrationCalls';

export default (service: Servicelayer) => ({
  ...IntegrationCallsApi(service),

  // Add custom calls here

});
